import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import styled from 'styled-components';
import GenericButton from '../../components/GenericButton';
import GenericInputWithEye from '../../components/GenericInputWithEye';
import { ChangePassword } from '../../models/ChangePassword';
import { useAppDispatch } from '../../redux/hooks';
import useModalStrip from '../../hooks/global-hooks/useModalStrip';
import { changePassword } from '../../redux/entities/userEntity';
import { useNavigate } from 'react-router-dom';

const PageHeading = styled.h2`
  margin-top: 3rem;
  font-weight: 600;
  color: #4a90e2;
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 1.5rem;
  letter-spacing: 0.5px;
`;

const AddButtonContainer = styled.div`
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
`;


const ChangePasswordPage: React.FC = () => {
  const [request, setRequest] = useState<ChangePassword>({} as ChangePassword);
  const dispatch = useAppDispatch();
  const { showModalStrip } = useModalStrip();
  const navigate = useNavigate();


  const handleChangePassword = () => {
    if (!request?.newPassword || !request.oldPassword) {
      alert("All fields are mandatory");
      return;
    }

    dispatch(changePassword(request))
      .unwrap()
      .then(res => {
        showModalStrip('success', "Password changed successfully. Please login back", 5000);
        localStorage.clear();
        setRequest({} as ChangePassword);
        navigate('/');
      }).catch(err => {
        showModalStrip('danger', err.message, 5000);
      })


  }


  return (
    <Container>
      <PageHeading>Change Password</PageHeading>

      {/* Add New User Button and Search Box */}
      <AddButtonContainer>
        {/* Add New User Button */}
        <GenericInputWithEye
          label='Current Password'
          value={request.oldPassword}
          type='password'
          onChange={(e) => setRequest({ ...request, oldPassword: e })}
        />
        <GenericInputWithEye
          label='New Password'
          value={request.newPassword}
          type='password'
          onChange={(e) => setRequest({ ...request, newPassword: e })}
        />
        <GenericButton label='Save' onClick={() => handleChangePassword()} />
      </AddButtonContainer>
    </Container>
  );
};

export default ChangePasswordPage;
